import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type {
  MaterialFormValues,
  MaterialResource,
  MaterialUpdatePayload,
} from "../types";

const updateMaterial = async (payload: MaterialUpdatePayload) => {
  const response = (await stellar.action("editMaterial", payload)) as {
    material?: MaterialResource;
  };

  return response.material ?? (payload as MaterialResource);
};

export const useUpdateMaterialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMaterial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["materials"] });
    },
  });
};
